import styled from "@emotion/styled/macro";
import {
  Button,
  SvgIcon,
  SvgNames,
  tokens,
  Typography,
} from "@sunrun/experience-ui-components";
import { useCallback } from "react";
import currentImage from "../../assets/images/currentImage.png";
import runXImage from "../../assets/images/runXDashboard.png";

const UserGuides = () => {
  const goToCurrent = useCallback(() => {
    window.open(
      "https://current.sunrun.com/site/7b6848bd-8bfb-5e2e-b56d-41b94260487d/content?type=page&pageCategoryId=5daf3824-a623-53e2-a6e8-06a6ec0120a0",
      "_blank"
    );
  }, []);
  const goToRunX = useCallback(() => {
    window.open("https://sunrun.docebosaas.com/learn", "_blank");
  }, []);
  return (
    <>
      <Typography
        style={{ padding: "20px 32px" }}
        size={28}
        color={tokens.BRAND_HERO_BLUE}
      >
        User Guides
      </Typography>
      <UserGuideContainer>
        <UserGuideInfo>
          <Typography
            color={tokens.BRAND_HERO_BLUE}
            size={18}
            fontWeight={"medium"}
            lineHeight={21}
            style={{ marginBottom: 8 }}
          >
            Current
          </Typography>
          <Typography
            size={14}
            color={tokens.TINTS_OFF_WHITE_20}
            lineHeight={20}
          >
            Current has knowledge articles to teach you how to use ONE.
          </Typography>
          <Typography
            size={14}
            color={tokens.TINTS_OFF_WHITE_20}
            lineHeight={20}
            style={{ marginBottom: 24 }}
          >
            Search any question you have with "in ONE" at the end, for instance,
            "How do I upload a utility bill in ONE?
          </Typography>
          <GoButton onClick={goToCurrent}>
            <Typography>Go to Current</Typography>
            <SvgIcon
              width={24}
              height={24}
              color={"white"}
              name={SvgNames.ExternalLink}
            />
          </GoButton>
        </UserGuideInfo>
        <UserGuideImage $type={currentImage}></UserGuideImage>
      </UserGuideContainer>
      <UserGuideContainer>
        <UserGuideInfo>
          <Typography
            color={tokens.BRAND_HERO_BLUE}
            size={18}
            fontWeight={"medium"}
            lineHeight={21}
            style={{ marginBottom: 8 }}
          >
            RunX Learning
          </Typography>
          <Typography
            size={14}
            color={tokens.TINTS_OFF_WHITE_20}
            lineHeight={20}
            style={{ marginBottom: 24, minHeight: 100 }}
          >
            Access your required and optional RunX learning courses. Your
            required training will show up under the 'Assigned Training' tab.
          </Typography>
          <GoButton onClick={goToRunX}>
            Go to RunX Learning
            <SvgIcon
              width={24}
              height={24}
              color={"white"}
              name={SvgNames.ExternalLink}
              style={{ marginLeft: 8 }}
            />
          </GoButton>
        </UserGuideInfo>
        <UserGuideImage $type={runXImage}></UserGuideImage>
      </UserGuideContainer>
    </>
  );
};

const GoButton = styled(Button)`
  line-height: 22px;
  padding: 8px 24px;
  font-weight: 400;

  & > span {
    display: flex;
    font-size: 16px;
    max-height: 24px;
    line-height: 24px;
    gap: 8px;
  }
`;

const UserGuideContainer = styled.div`
  margin-left: 32px;
  padding: 20px 24px;
  width: 600px;
  display: flex;
  flex-direction: row;
  border: solid 1px ${tokens.TINTS_OFF_WHITE_40}; //#D0CCC3
  border-radius: 8px;
  gap: 48px;
  margin-bottom: 32px;
`;

const UserGuideInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 274px;
  height: 194px;
`;

const UserGuideImage = styled.div<{ $type: string }>`
  display: flex;
  border-radius: 8px;
  border: 1px solid ${tokens.TINTS_OFF_WHITE_40};
  width: 276px;
  height: 194px;
  background-image: url(${({ $type }) => $type});
  background-repeat: no-repeat;
  background-position: top left;
  background-size: cover;
`;

export { UserGuides };
